import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Pedidos",
    items: [
      { label: "Pedidos",        icon: "fas fa-shopping-basket", href: "/ListadoPedidos",       key: "ventas.pedidos.ver"  },
      // { label: "Pedidos Diseño", icon: "fas fa-shopping-basket", href: "/ListadoPedidosDiseno", perm: "menu_pedidos"  },
      { label: "Venta Directa",  icon: "fas fa-cash-register",   href: "/VentaDirecta",         key: "ventas.ventaDirecta.ver"  },
      { label: "Entregar",       icon: "fas fa-truck-moving",    href: "/ListadoPendienteSurtir", key: "ventas.entregar.ver" },
    ],
  },
  {
    title: "Operación",
    items: [
      { label: "Devoluciones",        icon: "fas fa-undo-alt",    href: "/ListadoDevoluciones", key: "ventas.devoluciones.ver"       },
      // { label: "Venta Salderos",      icon: "fas fa-dollar-sign", href: "/VentaSalderos",       perm: "menu_pedidos"            },
      // { label: "Seguimiento Pedidos", icon: "fas fa-chart-bar",   href: "/SeguimientoPedidos",  perm: "menu_seguimientoPedidos" },
    ],
  },
  {
    title: "Reportes",
    items: [
      { label: "Recordatorio Clientes", icon: "fas fa-phone-volume", href: "/ReporteRecordatorio", key: "ventas.recordatorio.ver" },
    ],
  },
];

function BotonesVentas() {
  return (
    <MenuGrid
      title="Pedidos"
      subtitle="Gestión de pedidos, entregas y devoluciones de venta"
      icon="fas fa-clipboard-list"
      accent={{ color: "#3b82f6", bg: "#eff6ff" }}
      modulo="ventas"
      sections={SECTIONS}
    />
  );
}

export default BotonesVentas;
